export default {
    ADMIN_LOGIN: "/api/admin/login",
    ANSWER_LSIT: "/api/answer/list",
    ANSWER_DETAIL: "/api/answer/detail",
    ANSWER_FULL_DETAILS: '/api/answer/full_details',
    ANSWER_PH1_SAVE: "/api/answer/save/ph1",
    DIAGNOSIS_ANALYSIS: '/api/diagnosis/analysis',
    DIAGNOSIS_CATEGORY_SAVE: '/api/diagnosis/category/save',
    DIAGNOSIS_ANALYSIS_RESET: '/api/diagnosis/category/reset',
    // DIAGNOSIS_AI_SUGGEST: '/api/diagnosis/suggest/ai',
    PAIN_DIARY_DETAIL: '/api/pain/diary/detail',
    FOUR_INIT: '/api/fd/init',
    FOUR_SAVE: '/api/fd/save',
    THREE_ASSESS_INIT: '/api/ta/init',
    THREE_ASSESS_SAVE: '/api/ta/save',
    PAIN_DIARY_SAVE: '/api/pain/diary/save',
    REPORT_DOWNLOAD: "/api/report/download",
    PHOTO_INIT_BIND: "/api/photo/bind/init",
    PHOTO_DETAIL: "/api/photo/detail",
    PHOTO_BIND_DETAIL: "/api/photo/bind/detail",
    PHOTO_BIND: "/api/photo/bind",
    USER_SEARCH: "/api/user/search",
    USER_LIST: "/api/user/list",
    USER_INFO: "/api/user/info",
    USER_INFO_UPDATE: '/api/user/info/update',
    USER_UPDATE: '/api/user/update',
    USER_CREATE: '/api/user/create',
    USER_ORDER_VALIDATE: '/api/user/order/validate',
    USER_SOURCE_LIST: '/api/user/source/list',
    USER_SOURCE_ADD: '/api/user/source/add',
    USER_SOURCE_UPDATE: '/api/user/source/update',
    USER_TAG_LIST: '/api/user/tag/list',
    USER_TAG_ADD: '/api/user/tag/add',
    USER_TAG_DELETE: '/api/user/tag/delete',
    USER_TAG_ALL: '/api/user/tag/list/all',
    USER_PROGRESS_STATUS_LIST: '/api/user/progress_status/list',
    USER_PROGRESS_UPDATE: '/api/user/progress_update',
    ORDER_VALIDATE: '/api/order/shop/validate',
    ORDER_REFUND: '/api/order/shop/refund',
    ACTION_SEARCH: '/api/action/search',
    CAMP_LIST: '/api/camp/list',
    CAMP_ADD: '/api/camp/add',
    CAMP_UPDATE: '/api/camp/update',
    CAMP_PURCHASE_LIST: '/api/camp/purchase/list',
    CAMP_PURCHASE_ADD: '/api/camp/purchase/add',
    CAMP_PURCHASE_UPDATE: '/api/camp/purchase/update',
    COURSE_LIST: '/api/course/list',
    COURSE_ADD: '/api/course/add',
    COURSE_UPDATE: '/api/course/update',
    COURSE_UPDATE_STATUS: '/api/course/update_status',
    COURSE_UPDATE_SEQ: '/api/course/update_seq',
    COURSE_DELETE: '/api/course/delete',
    COURSE_BATCH_UPDATE: '/api/course/batch_update',
    STATUS_LIST: '/api/status/list',
    STATUS_UPDATE: '/api/status/update',
    STATUS_DELETE: '/api/status/delete',
    MILESTONE_MODULES: '/api/milestone/modules',
    MILESTONE_LIST: '/api/milestone/list',
    MILESTONE_UPDATE: '/api/milestone/update',
    MILESTONE_DELETE: '/api/milestone/delete',
    MILESTONE_FIRST_STATUS: '/api/milestone/first_status',
    MILESTONE_LAST_STATUS: '/api/milestone/last_status',
    THERAPIST_LIST: '/api/rehabilitation/therapist/list',
    THERAPIST_ASSIGNMENT_LIST: '/api/rehabilitation/assignment/list',
    THERAPIST_ASSIGNMENT_UPDATE: '/api/rehabilitation/assignment/update',
    REHAB_APPOINTMENT_LIST: '/api/rehabilitation/appointment/list',
    REHAB_APPOINTMENT_ADD: '/api/rehabilitation/appointment/add',
    REHAB_APPOINTMENT_UPDATE: '/api/rehabilitation/appointment/update',
    STATISTICS_USER_FLOW: '/api/statistics/user/flow/search',
}


// WEBPACK FOOTER //
// ./src/constants/requestUrl.js